<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasTopContent]="true"
  [hasCommonHeader]="true"
  [shouldGoBackToOverview]="selectedNewPaymentDate !== undefined"
>
  <div
    class="rs-panel-big rs-bg-c2 rs-box-shadow"
    data-cy="myBillDeferralSuccessfulNewDatePage"
    topContent
  >
    <h2 class="rs-tit3">
      {{ 'bills.deferral.successfulNewDate.title' | translate }}
    </h2>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <div
          class="rs-msgbox rs-msgbox-success"
          data-alert=""
          aria-live="assertive"
          role="alertdialog"
          *ngIf="selectedNewPaymentDate !== undefined"
          data-tms-event="popup-impression"
          data-tms-popup-zone="mybill.deferral_accept_new_date"
          data-tms-popup-name="success"
          [attr.data-tms-message-info]="billingAccountNumber"
          [attr.data-tms-context]="billDocument?.reference"
          data-cy="myBillDeferralSuccessfulNewDateSuccessInfoMessage"
        >
          <div class="rs-msgbox-title">
            {{
              'bills.deferral.successfulNewDate.successInfoBox.title'
                | translate
            }}
          </div>
          <div class="rs-msgbox-content">
            <p>
              {{
                'bills.deferral.successfulNewDate.successInfoBox.description'
                  | translate
              }}
            </p>
          </div>
          <div class="rs-msgbox-icon">
            <i class="icon-Validation-box" aria-hidden="true"></i>
          </div>
        </div>
        <p data-cy="myBillDeferralTotalToPay">
          <span class="rs-font-pxB"
            >{{ 'bills.deferral.successfulNewDate.totalToPay' | translate }}
          </span>
          <px-currency-amount
            [amountClass]="'rs-price-sm'"
            [amount]="billDocument?.amount"
          ></px-currency-amount>
        </p>
        <hr />
        <div class="row">
          <div class="small-12 medium-6 columns">
            <p class="rs-font-pxB" data-cy="myBillDeferralInitialDate">
              {{
                'bills.deferral.successfulNewDate.initialPaymentDate'
                  | translate
              }}<br />{{ billDocument?.dueDate }}
            </p>
          </div>
          <div class="small-12 medium-6 columns">
            <p class="rs-font-pxB" data-cy="myBillDeferralDeferredDate">
              {{ 'bills.deferral.successfulNewDate.newPaymentDate' | translate
              }}<br /><span class="rs-txt-success">{{
                selectedNewPaymentDate ?? billDocument?.deferralDate
              }}</span>
            </p>
          </div>
        </div>

        <hr class="show-for-small-only" />
      </div>
      <div class="small-12 medium-6 columns">
        <my-bill-deferral-rules-list></my-bill-deferral-rules-list>
        <!-- on successful deferral date, user should navigate back to overview instead of previous page -->

        <my-bill-back-button
          [customLabel]="
            selectedNewPaymentDate !== undefined
              ? 'bills.deferral.successfulNewDate.backToOverviewBtn'
              : 'bills.deferral.successfulNewDate.backBtn'
          "
          [backButtonType]="'lastButton'"
          [shouldGoBackToOverview]="selectedNewPaymentDate !== undefined"
          [forceDisplayOfBackButton]="selectedNewPaymentDate !== undefined"
        ></my-bill-back-button>
      </div>
    </div>
  </div>
</my-bill-odb-page-base-structure>
